export enum ETableHeaderLayoutMode {
  NONE = 'none',
  STICKY_LEFT = 'sticky-left',
  STICKY_RIGHT = 'sticky-right',
}
